module.exports = __webpack_public_path__ + "img/michigan.355e8a0e.png";